import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import Link from '@material-ui/icons/Link';
import AttachFile from '@material-ui/icons/AttachFile';
import Wallpaper from '@material-ui/icons/Wallpaper';
import InsertEmoticon from '@material-ui/icons/InsertEmoticon';
import PeopleOutline from '@material-ui/icons/PeopleOutline';

const EmptyStateList: FC = () => {
  const { t } = useTranslation();

  return (
    <List>
      <ListItem disableGutters>
        <ListItemIcon>
          <Link />
        </ListItemIcon>
        <ListItemText primary={t('discussions:emptyLink')} />
      </ListItem>
      <ListItem disableGutters>
        <ListItemIcon>
          <AttachFile />
        </ListItemIcon>
        <ListItemText primary={t('discussions:emptyUpload')} />
      </ListItem>
      <ListItem disableGutters>
        <ListItemIcon>
          <Wallpaper />
        </ListItemIcon>
        <ListItemText primary={t('discussions:emptyGif')} />
      </ListItem>
      <ListItem disableGutters>
        <ListItemIcon>
          <InsertEmoticon />
        </ListItemIcon>
        <ListItemText primary={t('discussions:emptyReaction')} />
      </ListItem>
      <ListItem disableGutters>
        <ListItemIcon>
          <PeopleOutline />
        </ListItemIcon>
        <ListItemText primary={t('discussions:emptyMention')} />
      </ListItem>
    </List>
  );
};

export default EmptyStateList;
